import { DiaryType } from "Components/DiaryCalendar";
import {
  addDays,
  endOfMonth,
  startOfMonth,
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
} from "date-fns";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";

export const getIntervalByDiaryType = (
  dateSelected: Date, 
  viewMode: DiaryType,
  timezone?: string // Timezone opcional (ex: 'America/Sao_Paulo', 'UTC', 'Europe/London')
) => {
  
  // Função auxiliar para converter data para timezone específico e depois para UTC
  const getDateInTimezone = (date: Date, tz: string) => {
    // Converte a data para o timezone especificado
    const zonedDate = utcToZonedTime(date, tz);
    return zonedDate;
  };

  // Função auxiliar para converter de volta para UTC mantendo o horário local
  const convertToUtc = (date: Date, tz: string) => {
    return zonedTimeToUtc(date, tz);
  };

  if ([DiaryType.RESOURCES, DiaryType.DAY].includes(viewMode)) {
    let startDate: Date;
    let endDate: Date;

    if (timezone) {
      // Converte a data selecionada para o timezone especificado
      const localDate = getDateInTimezone(dateSelected, timezone);
      
      // Obtém o início e fim do dia no timezone local
      const localStartOfDay = startOfDay(localDate);
      const localEndOfDay = endOfDay(localDate);
      
      // Converte de volta para UTC
      startDate = convertToUtc(localStartOfDay, timezone);
      endDate = convertToUtc(localEndOfDay, timezone);
    } else {
      // Comportamento padrão (UTC)
      startDate = startOfDay(dateSelected);
      endDate = endOfDay(dateSelected);
    }

    return {
      startDate,
      startDateISO: startDate.toISOString(),
      endDate,
      endDateISO: endDate.toISOString(),
    };
  }

  if (viewMode === DiaryType.MONTH) {
    let startDate: Date;
    let endDate: Date;

    if (timezone) {
      const localDate = getDateInTimezone(dateSelected, timezone);
      const localStartOfMonth = startOfMonth(localDate);
      const localEndOfMonth = endOfMonth(localDate);
      
      startDate = convertToUtc(localStartOfMonth, timezone);
      endDate = convertToUtc(localEndOfMonth, timezone);
    } else {
      startDate = startOfMonth(dateSelected);
      endDate = endOfMonth(dateSelected);
    }

    return {
      startDate,
      startDateISO: startDate.toISOString(),
      endDate,
      endDateISO: endDate.toISOString(),
    };
  }

  if (viewMode === DiaryType.WEEK) {
    let startDate: Date;
    let endDate: Date;

    if (timezone) {
      const localDate = getDateInTimezone(dateSelected, timezone);
      const localStartOfWeek = startOfWeek(localDate);
      const localEndOfWeek = endOfWeek(localDate);
      
      startDate = convertToUtc(localStartOfWeek, timezone);
      endDate = convertToUtc(localEndOfWeek, timezone);
    } else {
      startDate = startOfWeek(dateSelected);
      endDate = endOfWeek(dateSelected);
    }

    return {
      startDate,
      startDateISO: startDate.toISOString(),
      endDate,
      endDateISO: endDate.toISOString(),
    };
  }

  if (viewMode === DiaryType.LIST) {
    let startDate: Date;
    let endDate: Date;

    if (timezone) {
      const localDate = getDateInTimezone(dateSelected, timezone);
      const localStartDate = addDays(localDate, -3);
      const localEndDate = addDays(localDate, 3);
      
      startDate = convertToUtc(localStartDate, timezone);
      endDate = convertToUtc(localEndDate, timezone);
    } else {
      startDate = addDays(dateSelected, -3);
      endDate = addDays(dateSelected, 3);
    }

    return {
      startDate,
      startDateISO: startDate.toISOString(),
      endDate,
      endDateISO: endDate.toISOString(),
    };
  }

  throw new Error("Unsupported View Mode");
};

// Exemplo de uso:
// const result = getIntervalByDiaryType(new Date(), DiaryType.DAY, 'America/Sao_Paulo');
// const resultUTC = getIntervalByDiaryType(new Date(), DiaryType.DAY, 'UTC');
// const resultDefault = getIntervalByDiaryType(new Date(), DiaryType.DAY); // Sem timezone (comportamento original)
